import type {PublicMethodUtils} from '@wix/document-services-types'
import type {EffectsPublicAPI} from '@wix/document-services-public-types'
import {effects} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<EffectsPublicAPI> {
    const {extensionPublicAPI} = publicMethodUtils

    return {
        methods: {
            components: {
                effects: {
                    add: publicMethodUtils.defineDataManipulationAction(effects.addEffect, {
                        getReturnValue: effects.getEffectToAddPointer
                    }),
                    get: publicMethodUtils.defineGetter(effects.getEffect),
                    list: publicMethodUtils.defineGetter(effects.getComponentEffectList),
                    update: publicMethodUtils.defineDataManipulationAction(effects.updateEffectData),
                    remove: publicMethodUtils.defineDataManipulationAction(effects.removeEffect),
                    usesNewAnimations: publicMethodUtils.defineGetter(effects.usesNewAnimations),
                    usesNewBgScrub: extensionPublicAPI.getter('effects.usesNewBgScrub')
                }
            }
        }
    }
}
